// utils
import axios from '../utils/axios';
import tokenRenewalService from '../services/tokenrenewal.service';
import { logoutAfterSessionExpiry } from '../utils/sessionExpiredLogout';

// ----------------------------------------------------------------------

function jwtDecode(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`) // NOSONAR
      .join('')
  );

  return JSON.parse(jsonPayload);
}

// ----------------------------------------------------------------------

export const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

// ----------------------------------------------------------------------

let expiredTimer;

export const tokenExpired = (exp) => {

  const currentTime = Date.now();

  // Test token expires after 10s
  // const timeLeft = currentTime + 10000 - currentTime; // ~10s
  const timeLeft = exp * 1000 - currentTime;

  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(() => { // NOSONAR
    logoutAfterSessionExpiry();
  }, timeLeft);
};

// ----------------------------------------------------------------------

export const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);

    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    axios.defaults.headers.common.authheader = accessToken;

    const { exp } = jwtDecode(accessToken); 
    tokenExpired(exp);
    tokenRenewalService.start(accessToken, {
      onRenewed: (renewedToken) => setSession(renewedToken),
      onUnauthorized: logoutAfterSessionExpiry,
    });
  } else {
    clearTimeout(expiredTimer);
    tokenRenewalService.stop();
    localStorage.removeItem('accessToken');

    delete axios.defaults.headers.common.Authorization;
    delete axios.defaults.headers.common.authheader;
  }
};


